import Link from 'next/link';

/** 属性定義 */
type Props = {
  imgSrc: string;
  href: string;
  className?: string;
  alt?: string;
  target?: string;
  onClick?: (e: React.UIEvent<Element, UIEvent>) => void;
};

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const AtImageLink = ({
  imgSrc,
  href,
  className,
  alt,
  target,
  onClick
}: Props) => {
  return <Link href={href} target={target} onClick={onClick} className={`atimagelink ${className}`}>
      <img src={imgSrc} alt={alt} />
    </Link>;
};
/** 初期値の設定 */
AtImageLink.defaultProps = {
  className: '',
  alt: '',
  target: '_self',
  onClick: null
};
export default AtImageLink;